import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type TagType = 'default' | 'pain' | 'focus';

@Component({
  selector: 'app-plan-tags',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './plan-tags.component.html',
})
export class PlanTagsComponent {
  @Input() icon: string = '';
  @Input() label: string = '';
  @Input() value: string = '';
  @Input() type: TagType = 'default';
  @Input() showTag: boolean = false;
  @Input() isClickable: boolean = false;

  /**
   * Check if icon is a PrimeNG icon
   */
  isPrimeIcon(): boolean {
    return this.icon.startsWith('pi');
  }

  /**
   * Split the value to separate the main text from the "+X" indicator
   */
  getDisplayParts(): { mainText: string; plusIndicator: string | null } {
    const plusMatch = this.value.match(/^(.*?)(\s*\+\d+)$/);
    if (plusMatch) {
      return {
        mainText: plusMatch[1].trim(),
        plusIndicator: plusMatch[2].trim()
      };
    }
    return {
      mainText: this.value,
      plusIndicator: null
    };
  }
}
